import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';

import { AfcSubmissionCandidateReputationSchema } from './afc-submission-candidate-reputation';
import { CandidateSchema } from './candidate';
import { CandidateOpportunityDisplayBillingRates } from './candidate-opportunities';

export const AfcSubmissionCandidateSchema = CandidateSchema.pick({
  addressCity: true,
  addressCountry: true,
  addressState: true,
  badges: true,
  barredLocations: true,
  businessTitle: true,
  calculatedDisplayName: true,
  calculatedFirstName: true,
  calculatedLastName: true,
  calendar: true,
  candidateSummary: true, // Bad Prop APCORE-2591
  certifications: true,
  degrees: true,
  experiences: true,
  firstName: true, // Bad Prop APCORE-2591
  hoursPerDay: true,
  id: true,
  industries: true,
  isProfileShared: true,
  languages: true,
  lawFirms: true,
  lawDegreeSchools: true,
  position: true, // Bad Prop APCORE-2591
  primaryFocusArea: true,
  primaryPracticeArea: true,
  profileImageKey: true,
  profileStatus: true, // Bad Prop APCORE-2591
  pronouns: true,
  publicRefId: true,
  showReputation: true,
  weeklyAvailability: true,
  yearsOfExperience: true,
}).extend({
  proposedHourlyRate: z.number().nullish(), // Bad Prop APCORE-2591
  displayBillingRate: z
    .enum(ZodArrayToEnum(CandidateOpportunityDisplayBillingRates))
    .nullable(), // Bad Prop APCORE-2591
  candidateReputation: AfcSubmissionCandidateReputationSchema.nullable(),
});

export type AfcSubmissionCandidate = z.infer<
  typeof AfcSubmissionCandidateSchema
>;
